import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ElectronicInvoiceInterfaceChartModel } from 'src/app/models/charts/invoicing/electronic-invoice-interface-chart.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ElectronicInvoiceInterfaceDetailCaptureTableModel } from 'src/app/models/tables/invoicing/electronic-invoice-interface-detail-capture-table.model';
import { ElectronicInvoiceInterfaceDetailTableModel } from 'src/app/models/tables/invoicing/electronic-invoice-interface-detail-table.model';
import { ElectronicInvoiceInterfaceTableModel } from 'src/app/models/tables/invoicing/electronic-invoice-interface-table-model';
import { environment } from 'src/environments/environment';
import { enpointCervinoWeb } from './../../configuration/enpointsCervino';
import { ElectronicInvoiceInterfaceModel } from './../../models/invoicing/electronic-invoice-interface.model';

@Injectable({
  providedIn: 'root'
})
export class ElectronicInvoiceInterfaceService {

  constructor(private _httpClient: HttpClient) { }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetColumnsForGeneralConsultationAsync}`);
  }

  getElectronicInvoiceInterfaceForGeneralConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<ElectronicInvoiceInterfaceTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<ElectronicInvoiceInterfaceTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetElectronicInvoiceInterfacesForGeneralConsultation}`,
      filters, { params: params }
    );
  }

  getElectronicInvoiceInterfaceById(electronicInvoiceInterfaceId: number): Observable<ElectronicInvoiceInterfaceModel> {
    return this._httpClient.get<ElectronicInvoiceInterfaceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetElectronicInvoiceInterfaceById}/${electronicInvoiceInterfaceId}`);
  }

  getElectronicInvoiceInterfaceByKeysAsync(branchId: number, enterpriseId: number, consecutive: number): Observable<ElectronicInvoiceInterfaceModel> {
    const params = new HttpParams()
      .set('branchId', branchId)
      .set('enterpriseId', enterpriseId)
      .set('consecutive', consecutive);
    return this._httpClient.get<ElectronicInvoiceInterfaceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetElectronicInvoiceInterfaceByKeys}`, { params: params });
  }

  getFirstElectronicInvoiceInterfaceByKeysAsync(branchId: number, enterpriseId: number): Observable<ElectronicInvoiceInterfaceModel> {
    const params = new HttpParams()
      .set('branchId', branchId)
      .set('enterpriseId', enterpriseId);
    return this._httpClient.get<ElectronicInvoiceInterfaceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetFirstElectronicInvoiceInterfaceByKeys}`, { params: params });
  }

  getIndicatorsForDetailConsultation(filters: ColumnResponseModel[]): Observable<ElectronicInvoiceInterfaceChartModel> {
    return this._httpClient.post<ElectronicInvoiceInterfaceChartModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetIndicatorsForDetailConsultation}`,
      filters
    );
  }

  getLastElectronicInvoiceInterfaceByKeysAsync(branchId: number, enterpriseId: number): Observable<ElectronicInvoiceInterfaceModel> {
    const params = new HttpParams()
      .set('branchId', branchId)
      .set('enterpriseId', enterpriseId);
    return this._httpClient.get<ElectronicInvoiceInterfaceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetLastElectronicInvoiceInterfaceByKeys}`, { params: params });
  }

  getPreviusElectronicInvoiceInterfaceByKeysAsync(branchId: number, enterpriseId: number, consecutive: number | null): Observable<ElectronicInvoiceInterfaceModel> {
    let params = new HttpParams()
      .set('branchId', branchId)
      .set('enterpriseId', enterpriseId);
    if (consecutive !== null)
      params = params.set('consecutive', consecutive);
    return this._httpClient.get<ElectronicInvoiceInterfaceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetPreviusElectronicInvoiceInterfaceByKeys}`, { params: params });
  }

  getNextElectronicInvoiceInterfaceByKeysAsync(branchId: number, enterpriseId: number, consecutive: number | null): Observable<ElectronicInvoiceInterfaceModel> {
    let params = new HttpParams()
      .set('branchId', branchId)
      .set('enterpriseId', enterpriseId);
    if (consecutive !== null)
      params = params.set('consecutive', consecutive);
    return this._httpClient.get<ElectronicInvoiceInterfaceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetNextElectronicInvoiceInterfaceByKeys}`, { params: params });
  }

  attachGraphicRepresentationFiles(documentId: number, files: FormData, isInvoice: boolean): Observable<Array<string>> {
    return this._httpClient.post<Array<string>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.AttachGraphicRepresentationFiles}/${documentId}/${isInvoice}`, files);
  }

  //Servicios del detalle
  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.ExportDetailConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetColumnsForDetailConsultationAsync}`);
  }

  getColumnsForDetailCapture(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetColumnsForDetailCaptureAsync}`);
  }

  getElectronicInvoiceInterfaceDetailsForDetailConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<ElectronicInvoiceInterfaceDetailTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<ElectronicInvoiceInterfaceDetailTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetElectronicInvoiceInterfaceDetailsForDetailConsultation}`,
      filters, { params: params }
    );
  }

  getElectronicInvoiceInterfaceDetailById(electronicInvoiceInterfaceId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<ElectronicInvoiceInterfaceDetailCaptureTableModel>> {
    const params = new HttpParams()
      .set('electronicInvoiceInterfaceId', electronicInvoiceInterfaceId)
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<ElectronicInvoiceInterfaceDetailCaptureTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetElectronicInvoiceInterfaceDetailByIdAsync}`,
      filters, { params: params }
    );
  }

  getDocumentsForGeneratePdfAsync(electronicInvoiceInterfaceId: number, documentIds: number[]): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicInvoiceInterface.GetDocumentsForGeneratePdfAsync}/${electronicInvoiceInterfaceId}`, documentIds);
  }
}
